import { useId, useRef, useState } from 'react'
import { Add20Regular } from '@/components/Icon'
import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import { IconButton } from '@mui/material'
import Tooltip from '@/components/Tooltip'
import { ATTACH_MENU_ITEM_IDS, ATTACH_MENU_ITEMS } from './aiAskBarAttachMenuItems'
import styles from './index.module.scss'

export default function AiAskBarAttachAction({
  disabled,
  onUpload,
  onSelectFromDocuments,
}) {
  const buttonRef = useRef(null)
  const listId = useId()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip text="add" placement="bottom">
        <IconButton
          ref={buttonRef}
          type="button"
          className={styles.circleAction}
          onClick={() => setOpen(true)}
          aria-label="Add"
          aria-haspopup="menu"
          aria-expanded={open}
          aria-controls={open ? listId : undefined}
          disabled={disabled}
        >
          <Add20Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      <FloatingMenuPopup
        open={open}
        anchorEl={buttonRef.current}
        onClose={() => setOpen(false)}
        hideBackdrop
        reserveIconSpace
        items={ATTACH_MENU_ITEMS}
        onItemSelect={(id) => {
          if (id === ATTACH_MENU_ITEM_IDS.UPLOAD) onUpload?.()
          if (id === ATTACH_MENU_ITEM_IDS.DOCUMENTS) onSelectFromDocuments?.()
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        menuListId={listId}
        menuListAriaLabel="Add attachment"
      />
    </>
  )
}
